var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPisces(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.668 40 1.118-1.15c-5.098-4.817-7.78-11.181-8.093-17.723h7.11V19.36h-7.155c.134-6.541 2.683-13.083 7.646-18.254L27.131 0c-5.276 5.48-7.959 12.42-8.093 19.36H9.962A28.553 28.553 0 0 0 1.869 0L.706 1.105C5.67 6.276 8.218 12.818 8.352 19.359H1.913v1.768h6.394C7.994 27.67 5.312 34.033.214 38.807l1.118 1.149c5.41-5.127 8.272-11.934 8.585-18.873h9.121c.313 6.983 3.175 13.79 8.63 18.917z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPisces);
export default __webpack_public_path__ + "static/media/pisces.0d227dae89a57eaf66060f3aca904a67.svg";
export { ForwardRef as ReactComponent };